module.exports = __webpack_public_path__ + "static/violin_cn-a830677de2f5d2f7589835e085dd2671.pdf";